import { Directive, ElementRef, HostListener } from '@angular/core';
import { TextToSpeechService } from '../services/text-to-speech.service';

@Directive({
  selector: '[appTextToSpeech]',
  // standalone: true
})
export class TextToSpeechDirective {

  constructor(private el: ElementRef, private speechService: TextToSpeechService) {}

  // Hover event to start speech
  @HostListener('mouseover') onMouseOver() {
    if (this.speechService.isSpeechFeatureEnabled()) {
      // this.speechService.speak(this.el.nativeElement.innerText);
    }
  }

  // Mouseup event to speak selected text
  @HostListener('mouseup') onMouseUp() {
    if (this.speechService.isSpeechFeatureEnabled()) {
      const selectedText = window.getSelection()?.toString();
      if (selectedText) {
        this.speechService.speak(selectedText);
      }
    }
  }
}
